import type { SqlDriver } from './driver.ts';

/** Bump when the local schema changes; older caches are rebuilt by a full resync. */
export const LOCAL_SCHEMA_VERSION = 1;

const STATEMENTS = [
  `create table if not exists meta (key text primary key, value text not null)`,
  `create table if not exists entities (
     entity_type text not null,
     id text not null,
     household_id text not null,
     version integer not null default 0,
     deleted integer not null default 0,
     data text,
     local text,
     local_deleted integer not null default 0,
     sync_state text not null default 'synced',
     date_key text,
     gen integer not null default 0,
     updated_at text not null,
     primary key (entity_type, id)
   )`,
  `create index if not exists entities_by_type on entities (household_id, entity_type, date_key)`,
  `create table if not exists outbox (
     seq integer primary key autoincrement,
     operation_id text not null unique,
     household_id text not null,
     entity_type text not null,
     entity_id text not null,
     action text not null,
     base_version integer,
     payload text,
     base text,
     created_at text not null,
     status text not null default 'queued',
     attempts integer not null default 0,
     next_attempt_at text,
     last_error text
   )`,
  `create index if not exists outbox_entity on outbox (entity_type, entity_id)`,
  `create table if not exists conflicts (
     id text primary key,
     household_id text not null,
     entity_type text not null,
     entity_id text not null,
     reason text not null,
     fields text not null,
     server_entity text,
     local_state text,
     local_patch text,
     created_at text not null
   )`,
];

export async function migrateLocal(driver: SqlDriver): Promise<void> {
  await driver.transaction(async (tx) => {
    for (const statement of STATEMENTS) await tx.run(statement);
    const rows = await tx.all<{ value: string }>(`select value from meta where key = 'schemaVersion'`);
    if (rows.length === 0) {
      await tx.run(`insert into meta (key, value) values ('schemaVersion', ?)`, [String(LOCAL_SCHEMA_VERSION)]);
    }
  });
}
